import { render, staticRenderFns } from "./GoodsReturn.vue?vue&type=template&id=500c0886&scoped=true&"
import script from "./GoodsReturn.vue?vue&type=script&lang=js&"
export * from "./GoodsReturn.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReturn.vue?vue&type=style&index=0&id=500c0886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c0886",
  null
  
)

export default component.exports